// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"e4bb707c","508":"754aaee3","835":"a2bddec9","855":"67506291"}[chunkId] + ".chunk.css";
};